import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "../components/AppShell";
import api from "../lib/api";
import { toast } from "sonner";
import { Trash2, CalendarDays } from "lucide-react";

function groupByDay(items) {
  const map = {};
  items.forEach((it) => {
    const d = (it.scheduled_at || "").slice(0,10);
    map[d] = map[d] || [];
    map[d].push(it);
  });
  return Object.entries(map).sort(([a],[b]) => a.localeCompare(b));
}

export default function Schedule() {
  const [items, setItems] = useState([]);
  const nav = useNavigate();

  const load = async () => { const { data } = await api.get("/schedule"); setItems(data); };
  useEffect(() => { load(); }, []);

  const remove = async (id) => { await api.delete(`/schedule/${id}`); toast.success("Removed"); load(); };

  const groups = groupByDay(items);

  return (
    <AppShell eyebrow="Drops" title="Content Schedule">
      <p className="text-sm text-zinc-600 max-w-2xl mb-8">Your distribution rhythm at a glance. Open a piece to edit, copy or publish manually. Reminders coming soon.</p>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-zinc-200 border border-zinc-200">
        {groups.length === 0 && <div className="bg-white p-8 text-sm text-zinc-500 lg:col-span-3" data-testid="schedule-empty">Nothing scheduled. Open any piece in Content Studio → Schedule.</div>}
        {groups.map(([day, list]) => (
          <div key={day} className="bg-white p-5">
            <div className="flex items-center gap-2 mb-3">
              <CalendarDays className="w-4 h-4 text-[#0033FF]" />
              <div className="text-xs tracking-[0.25em] uppercase font-bold">{new Date(day).toLocaleDateString(undefined, { weekday:"short", month:"short", day:"numeric" })}</div>
            </div>
            <div className="space-y-2">
              {list.map((it) => (
                <div key={it.id} className="border border-zinc-200 p-3 hover:bg-zinc-50" data-testid={`sched-item-${it.id}`}>
                  <div className="flex items-start justify-between gap-2">
                    <button onClick={()=>nav(`/content/${it.content_id}`)} className="text-left min-w-0 flex-1">
                      <div className="text-[10px] tracking-[0.2em] uppercase text-[#0033FF] font-bold">{it.channel}</div>
                      <div className="text-sm font-bold tracking-tight truncate">{it.content_title || it.content_id?.slice(0,8)}</div>
                      <div className="text-xs text-zinc-500 font-mono">{new Date(it.scheduled_at).toLocaleTimeString([], { hour:"2-digit", minute:"2-digit" })}</div>
                      <div className="text-xs text-zinc-600 line-clamp-2 mt-1">{it.preview}</div>
                    </button>
                    <button onClick={()=>remove(it.id)} data-testid={`sched-delete-${it.id}`} className="text-zinc-400 hover:text-[#FF3B30]">
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </AppShell>
  );
}
